<template>
  <div :class="sideNav">
   <div class="main_top">
    <h1 id="main_top" v-html="top_title">
    </h1>
    <div class="menu">
      <span v-show="noti" id="noti" class="noti">{{ noti }}</span>
      <div id="hamburger" @click="openMyInfo">
        <img src="images/basic/icon/menu.svg" alt="">
      </div>
    </div>
  </div>

  <!-- side menu -->
  <div id="side_menu" class="side_menu">
    <div class="side_head">
      <h1>
        <img src="images/basic/logo/logo.svg" alt="" height="20">
      </h1>
      <h1 id="close_sidenav" @click="closeSidenav">
        <img src="images/basic/icon/close-b.svg" alt="">
      </h1>
    </div>
    <div class="profile">
      <div class="profile_pic">
        <div class="crown">
          <img src="images/basic/icon/crown.svg" alt="">
        </div>
        <div class="pic_div" style="background-image:url('images/basic/img/profile@3x.png')"></div>
        <div class="icon">
          <i class="fas fa-camera"></i>
        </div>
      </div>
      <div class="profile_detail">
        <h3>서지현
          <a href="/profile" data-transition="slide" style="vertical-align: bottom;">
            <img src="images/basic/icon/more2.svg" alt="">
          </a>
        </h3>
        <div class="level_div">
          <span class="level">Lv.7</span>
          <span>EXP. 2,400/3,000</span>
          <div class="line">
            <div class="marker"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="side_fus_area">
      <div id="side_fus" class="fus_info">
        <div class="fus">
          <span class="fus_big">{{data_big}}</span><span class="fus_dot">.</span><span
            class="fus_small">{{data_small}}</span>
        </div>
        <div class="fus_help">
          <span>FUS</span><i class="far fa-question-circle"></i>
        </div>
        <div class="fus_krw">
          <span>1FUS = KRW{{data_krw}}</span>
          <span><i class="fas fa-sync-alt"></i></span>
        </div>
      </div>
      <div class="icon_send_div">
        <img onclick="location_sendCoin();" src="images/basic/icon/send-fus.svg" alt="">
      </div>
    </div>
    <div class="" id="detail_rate">
      <div class="">
        <span onclick="location_party();">파티원 <span class="rate">{{party}}</span></span>
      </div>
      <div class="">
        <span @click="goToMiningGuide">채굴가이드</span>
      </div>
      <div class="">
        <span onclick="location_order_list();">주문내역 <span class="rate">{{item}}</span></span>
      </div>
    </div>
    <div class="icon_menu">
      <div class="icon">
        <div onclick="location_level_info();" class="icon_invite_div">
          <div class="img"><img src="images/basic/icon/level-guide.svg" alt=""></div>
          <p>레벨안내</p>
        </div>
        <div @click="goToMyLikeList" class="icon_trophy_div">
          <div class="img"><img src="images/basic/icon/trophy.svg" alt=""></div>
          <p>내 좋아요 <span>{{trophy}}</span></p>
        </div>
        <div onclick="location_myPost();" class="icon_write_div">
          <div class="img"><img src="images/basic/icon/write.svg" alt=""></div>
          <p>내가쓴글 <span>{{write}}</span></p>
        </div>
        <div onclick="location_myReply();" class="icon_reply_div">
          <div class="img"><img src="images/basic/icon/reply.svg" alt=""></div>
          <p>댓글 <span>{{reply}}</span></p>
        </div>
      </div>
    </div>

    <div class="act_div">
      <h1>Activity</h1>
      <!-- fever -->
      <div class="list">
        <div class="act_list new">
          <div class="act_icon event" style="background-color:#FE5F57">
            <img src="images/basic/icon/fever.svg" alt="">
          </div>
          <p>FEVER 아이템이 도착했습니다.</p> <span class="fever_take">받기</span>
        </div>
        <!-- shopping -->
        <div class="act_list new">
          <div class="act_icon coin-get" style="background-color:#FF7100">
            <img src="images/basic/icon/shopping-reward.svg" alt="">
          </div>
          <p>쇼핑 페이백 FUS 적립</p> <span class="get_rate">+30</span>
        </div>
        <!-- send coin -->
        <div class="act_list new">
          <div class="act_icon coin-lose" style="background-color:#00B8D4">
            <img src="images/basic/icon/coin-send.svg" alt="">
          </div>
          <p>“별빛바다”님에게 송금</p> <span class="send_rate">-50</span>
        </div>
        <!-- roulette -->
        <div class="act_list">
          <div class="act_icon cooltime" style="background-color:#FFB800">
            <img src="images/basic/icon/roulette-cooltime.svg" alt="">
          </div>
          <p>룰렛을 돌리실 수 있습니다.</p>
        </div>
        <!-- party -->
        <div class="act_list">
          <div class="act_icon community" style="background-color:#1DA3EC">
            <img src="images/basic/icon/part-joined.svg" alt="">
          </div>
          <p>“나아지는것이없다”님이 파티원이 되었습니다.</p>
        </div>
        <!-- get coin -->
        <div class="act_list">
          <div class="act_icon" style="background-color:#00B8D4">
            <img src="images/basic/icon/mining-w.svg" alt="">
          </div>
          <p>FUS 채굴에 성공하였습니다.</p> <span class="get_rate">+0.1</span>
        </div>
        <!-- roulette -->
        <div class="act_list">
          <div class="act_icon" style="background-color:#FFB800">
            <img src="images/basic/icon/roulette-cooltime.svg" alt="">
          </div>
          <p>룰렛을 돌리실 수 있습니다.</p>
        </div>
        <!-- party -->
        <div class="act_list">
          <div class="act_icon" style="background-color:#1DA3EC">
            <img src="images/basic/icon/part-joined.svg" alt="">
          </div>
          <p>“나아지는것이없다”님이 파티원이 되었습니다.</p>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    top_title: {
      type: String,
      required: true
    }
  },
  created() {
    
  },
  data() {
    return {
      data_big: '2400',
      data_small: '05',
      data_krw: '2500',
      party: '34',
      coupon: '4',
      item: '2',
      trophy: '4',
      write: '3',
      reply: '9',
      sideNav: '',
    }
  },
  computed: {
    noti() {
      return this.$store.state.userInfo.activityNewCnt
    }
  },
  methods: {
    openMyInfo() {
      var varUA = navigator.userAgent.toLowerCase();

      if ( varUA.indexOf('android') > -1) {
        try{
          window.Android.openMyInfo();
        }catch( e ){
          this.sideNav = 'sider';
        }
      } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
        try{
          window.webkit.messageHandlers.openMyInfo.postMessage("open");
        }catch( e ){
          this.sideNav = 'sider';
        }
       //IOS
      } else {
        this.sideNav = 'sider';
          //아이폰, 안드로이드 외 
      }

      /*
      try {
        window.Android.openMyInfo();
      } catch ( e ) {
        this.sideNav = 'sider';
      // $( 'body' ).addClass( "sider" );
      }
      */
    },
    closeSidenav() {
      this.sideNav = '';
    },
    goToMyLikeList() {
      this.$router.push('/myLike')
    },
    goToMiningGuide() {
      this.$router.push('/mining_guide')
    }
  },

}
</script>

<style>

</style>